import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import pxToRem from "theme/base/pxToRem";
import { TimeSheet } from "../../MonthlyTimeKeeping/TimeSheet";
// import { SummaryTimeSheet } from "../../MonthlyTimeKeeping/SummaryTimeSheet";
import { SummaryCount } from "../../MonthlyTimeKeeping/styles";
import { timeKeepingManagerDetailDataSelector } from "modules/DeclareLeave/redux/selector";
import { SummaryTimeSheet } from "../../MonthlyTimeKeeping/SummaryTimeSheet";
import { resetTimeKeepingManagerDetail } from "modules/DeclareLeave/redux/getTimeKeepingManagerDetail";
import {
  confirmTimeKeepingStart,
  setDataConfirmTimeKeeping,
} from "modules/DeclareLeave/redux/confirmTimeKeeping";
import { STATUS_CONFIRM } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";

const ModalTimekeepingDetail = ({
  monthSelected,
}: {
  monthSelected: moment.Moment;
}) => {
  const dispatch = useDispatch();
  const timekeepingDetailDialog = useDialog(DIALOG.TIMEKEEPING_DETAIL_MANAGER);
  const data = useSelector(timeKeepingManagerDetailDataSelector);

  const open = useSelector(
    isOpenDialogSelector(DIALOG.TIMEKEEPING_DETAIL_MANAGER)
  );

  const handleClose = () => {
    dispatch(resetTimeKeepingManagerDetail());
    timekeepingDetailDialog.close();
  };

  const handleSubmit = () => {
    dispatch(
      setDataConfirmTimeKeeping({
        ids: [data?.employeeCode],
        month: monthSelected?.month() + 1,
        year: monthSelected?.year(),
      })
    );
    dispatch(
      confirmTimeKeepingStart({
        callback: () => handleClose(), // action khi confirm xong
      })
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      sx={(theme) => ({
        "& .MuiPaper-root": {
          background: theme.palette.background.bgTertiary,
          borderRadius: theme.borders.borderRadius.xl_12,
        },
      })}
    >
      <DialogTitle sx={{ background: "white" }}>
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Typography
            textAlign={"center"}
            flex={1}
            fontWeight={600}
            fontSize={pxToRem(16)}
          >
            Chi tiết chấm công
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ marginTop: pxToRem(24) }}>
        <Box
          sx={(theme) => ({
            border: `solid 1px ${theme.palette.colorsBase.blue_8}`,
            borderRadius: pxToRem(8),
            padding: "16px 20px",
          })}
        >
          <Box
            display={"flex"}
            justifyContent={"start"}
            alignItems={"center"}
            gap={pxToRem(12)}
            pb={pxToRem(10)}
            sx={(theme) => ({
              borderBottom: `solid 1px ${theme.palette.colorsBase.blue_9}`,
            })}
          >
            <Typography fontWeight={"bold"}>{data?.name}</Typography>{" "}
            <Box
              sx={(theme) => ({
                background: theme.palette.colorsBase.blue_9,
                width: "1px",
                height: "20px",
              })}
            ></Box>{" "}
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={pxToRem(5)}
            >
              <Typography
                sx={(theme) => ({ color: theme.palette.colorsBase.gray_6 })}
              >
                Mã nhân viên:{" "}
              </Typography>
              <Typography
                sx={(theme) => ({ color: theme.palette.colorsBase.gray_10 })}
              >
                {data?.employeeCode}
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={(theme) => ({
              borderBottom: `solid 1px ${theme.palette.colorsBase.blue_9}`,
            })}
            paddingBlock={pxToRem(10)}
          >
            {data?.positionName}{" "}
            {data?.departmentName && ` - ${data?.departmentName}`}
            {data?.departmentLevel2Name && ` - ${data?.departmentLevel2Name}`}
          </Typography>
          <Typography paddingBlock={pxToRem(10)}>
            Khu vực: {data?.workingAreaName}
          </Typography>
        </Box>
        <Box marginBlock={pxToRem(20)}>
          <TimeSheet timeSheetData={data?.workDays || {}} />
        </Box>
        <SummaryTimeSheet timeKeepingData={data?.leaveReasons} />
        <SummaryCount>
          <Typography
            sx={(theme) => ({
              fontSize: theme.typography.size.sm_14,
              textTransform: "uppercase",
              fontWeight: theme.typography.fw_semibold_600,
              color: theme.palette.text.textPrimary,
            })}
          >
            Tổng cộng ngày công tính lương nhân sự:
          </Typography>
          <Typography
            sx={(theme) => ({
              fontSize: theme.typography.size.sm_14,
              textTransform: "uppercase",
              fontWeight: theme.typography.fw_semibold_600,
              color: theme.palette.text.textLink,
            })}
          >
            {data?.totalWorkDays} NGÀY CÔNG
          </Typography>
        </SummaryCount>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="blur"
          sx={(theme) => ({
            width: "20%",
            fontWeight: 400,
            // mr: 1,
            background: theme.palette.background.bgSecondary,
            color: theme.palette.text.textPrimary,
          })}
        >
          Đóng
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          sx={(theme) => ({
            width: "100%",
            fontWeight: 400,
          })}
          fullWidth
          disabled={
            data?.confirmStatus !== STATUS_CONFIRM.APPROVE ||
            data?.confirmOfManager === STATUS_CONFIRM.APPROVE
          }
        >
          Xác nhận chấm công
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalTimekeepingDetail;
